/**
 * Without columns, a matrix with a secondaryDimensionA is fetched as
 * groupBy (A) -> subGroupBy (secondary A), so each row is its A value's own
 * row, aggregated by the server, with its secondary terms nested in `values`
 * (see flattenSecondaryDimensionRows):
 *
 *   { city, [m], values: [{ driver, [m] }] } -> { city, [m] }
 *
 * These are the parents stacked secondary rows are drawn under: right for
 * averages and compound metrics, where adding up the secondary rows wouldn't
 * be.
 */
const toSecondaryParentRows = (response: MetricsResponse): MetricsResponse =>
  response.map(({ values, ...row }) => row);

export default toSecondaryParentRows;
